export const SUBJECTS_DATA = [
  {
    assigment: 'Ingeniería de software',
    professor: 'Nombre Apellidos Profesor',
    type: 'Clase'
  },
  {
    assigment: 'Ingeniería de software',
    professor: 'Nombre Apellidos Profesor',
    type: 'Taller'
  },
  {
    assigment: 'Organización de computadoras y lenguaje ensamblador',
    professor: 'Nombre Apellidos Profesor',
    type: 'Clase'
  },
  {
    assigment: 'Organización de computadoras y lenguaje ensamblador',
    professor: 'Nombre Apellidos Profesor',
    type: 'Taller'
  }
];